export const formDefaultValues = {
  hideAbsentTurnsFromCashbox: false,
}
